import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CreateDocRule.scss';
import { withTranslation } from 'react-i18next';
import { BiPlus, BiTrash } from 'react-icons/bi';
import {
  Button, Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import DocumentModal from '../../../components/DocumentModal/DocumentModal';
import DocumentRuleService from '../../../core/service/DocumentRuleService';
import { toast } from "react-toastify";
import { useNavigate, useParams } from 'react-router-dom';
import RiskConfigService from '../../../core/service/RiskConfigService';
import { BsQuestionCircle } from "react-icons/bs";


const CreateDocRule = ({ t }) => {
  const searchkeyobj = {
    searchText: '',
    type: 'OR'
  };
  const occurrenceObj = {
    minimum: '',
    maximum: '',
    score: ''
  }
  const [showAllNew, setShowAllNew] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const [folderlist, setFolderList] = useState([]);
  const [searchkeywordlist, setSearchKeyList] = useState([searchkeyobj]);
  const [numberofocc, setNumberOfOcc] = useState([occurrenceObj]);
  const [ruletitle, setRuleTitle] = useState('');
  const [regInfo, setRegInfo] = useState("");
  const { reg_id } = useParams();
  const { rule_id } = useParams();
  const navigate = useNavigate();
  const [ruledata, setRuleData] = useState({});
  useEffect(() => {
    getRegulationDetails(reg_id);
    if (rule_id !== undefined && rule_id != null && rule_id !== '') {
      getRulesData();
    }
  }, {});

  const getRulesData = () => {
    DocumentRuleService.getList(reg_id)
      .then((response) => {
        let filter = (response.data).filter(x => x.id == rule_id);
        if (filter[0]) {
          setRuleData(filter[0]);
          setRuleTitle(filter[0].name);
          setSearchKeyList(filter[0].keywords);
          setFolderList(filter[0].folders);
          setNumberOfOcc(filter[0].ruleDefinitions);
        }
      })
      .catch((error) => {
        console.log("err", error);
      });
  };
  const handleShareFolderAdd = () => {
    let regObj = { id: parseInt(reg_id), name: regInfo.name };
    setShowAllNew(true);
    let obj = {
      isShow: true,
      action: "Select",
      regulation: regObj
    }
    setModalObj(obj);
  };
  const callbackDocumentModal = (obj) => {
    if (obj.isClose) {
      // let arr = [...folderlist];
      let dtObj = {
        id: obj.selFolder,
        name: obj.selectedFolderName
      }
      let arr = [];
      arr.push(dtObj);
      setFolderList(arr);

      setShowAllNew(false);
    }
  };

  const handleOrClick = () => {
    let arr = [...searchkeywordlist];
    arr.push(searchkeyobj);
    setSearchKeyList(arr);
  };


  const updateFieldChanged = (index) => (e) => {
    const newArr = searchkeywordlist.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    setSearchKeyList(newArr);
  };

  const occuranceChanged = (index) => (e) => {
    const newArr = numberofocc.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    setNumberOfOcc(newArr);
  };

  const addDefineRule = () => {
    let arr = [...numberofocc];
    arr.push(occurrenceObj);
    setNumberOfOcc(arr);
  };

  const removeDefineRule = (index) => {
    let arr = [...numberofocc];
    arr.splice(index, 1);
    setNumberOfOcc(arr);
  };

  const saveRule = (isEdit) => {
    let body = {
      name: ruletitle,
      folders: folderlist,
      keywords: searchkeywordlist,
      ruleDefinitions: numberofocc
    }
    if (isEdit) {
      body['id'] = rule_id
    }
    // return
    DocumentRuleService.saveData(reg_id, body)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/company_admin/document_rules/" + reg_id);
        }
      })
      .catch((error) => {
        console.log("error", error);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }
  const getRegulationDetails = (regId) => {
    RiskConfigService.getRegulationDetails(regId)
      .then((response) => {
        setRegInfo(response.data);
        // return response.data;
      })
      .catch((error) => {
      });
  };
  const FolderScannedHelpText = (
    <Tooltip id="Risk_help_test">
      {t("AllFilesSelectedFolderScannedToolTip.label")}
    </Tooltip>
  );
  const SearchKeywordHelpText = (
    <Tooltip id="Risk_help_test">
      {t("AddKeywordSearchedSelectedFolderToolTip.label")}
    </Tooltip>
  );
  return (
    <div className="CreateDocRule">
      <div className="card DocumentRules_card">
        <div className="card-body">
          <div>
            <h6>Create new rules</h6>
          </div>
          <div className="m-0">
            <div className="col-md-6 p-2">
              <label className="mb-1">Title of the Rule</label>
              <input type="text" className="form-control" placeholder="Enter title for the rule"
                value={ruletitle} onChange={(e) => setRuleTitle(e.target.value)} />
            </div>
            <div className="col-md-6 p-2">
              <label className="mb-1">Folder in which the files are to be scanned

                <OverlayTrigger
                  placement="bottom"
                  overlay={FolderScannedHelpText}
                >
                  <span className="ms-2  text-dark"><BsQuestionCircle /></span>
                </OverlayTrigger>
              </label>
              <div>
                {/* onClick={handleShow} */}
                <button className="btn btn_choose_folder" onClick={handleShareFolderAdd}>Choose a Folder</button>
              </div>
              {folderlist && folderlist.length > 0 && folderlist.map((item, index) => (
                <div className='p-2'><b>{item.name}</b></div>
              ))}
            </div>
            <div className="col-md-6 px-0 py-2">
              <div className="row m-0">
                <div className="col-12 px-2">
                  <label className="mb-1">Search Keyword
                    <OverlayTrigger
                      placement="bottom"
                      overlay={SearchKeywordHelpText}
                    >
                      <span className="ms-2  text-dark"><BsQuestionCircle /></span>
                    </OverlayTrigger>
                  </label>
                </div>
                {searchkeywordlist && searchkeywordlist?.map((searchitem, index) => (
                  <div className='row mb-2'>
                    <div className="col-11 px-2">
                      <input type="text" className="form-control" name='searchText' placeholder="Ente a text to search in the files"
                        onChange={updateFieldChanged(index)} value={searchitem.searchText} />
                    </div>
                    {(index === searchkeywordlist.length - 1) && <div className="col-1 px-1">
                      <Button className="btn btn-secondary" onClick={() => handleOrClick()}>OR</Button>
                    </div>}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-md-7 p-2 Define_Rules_Box">
              <h6>Define Rules</h6>

              {numberofocc && numberofocc.map((occitem, index) => (
                <div className="row mx-0 mb-2 Define_Rules_Row">
                  <div className="col-md-7 p-0">
                    <div className="row m-0 align-items-center">
                      <div className="col-md-6 px-2">
                        If the No.of occurrence is
                      </div>
                      <div className="col-md-6 p-0">
                        <ul className="Define_Rules_Box_ul">
                          <li><input type="text" className="form-control" name='minimum' placeholder="Minimum"
                            onChange={occuranceChanged(index)} value={occitem.minimum} /> </li>
                          <li>-</li>
                          <li><input type="text" className="form-control" name='maximum' placeholder="Maximum"
                            onChange={occuranceChanged(index)} value={occitem.maximum} /></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="Risk_Score-001">
                      <ul>
                        <li>
                          Then, Risk score is
                        </li>
                        <li><input type="text" className="form-control" name='score'
                          onChange={occuranceChanged(index)} value={occitem.score} /> </li>
                      </ul>

                      {(index !== 0 || numberofocc.length > 1) && <button className='btn btn-blank_outline Risk_Score-001_delete'
                        onClick={() => removeDefineRule(index)}><BiTrash /></button>}
                    </div>
                  </div>
                </div>))}
              <div>
                <Button variant="secondary" onClick={() => addDefineRule()}><BiPlus />New Rule</Button>
              </div>
            </div>
          </div>
          <div className="p-2">
            <Button variant="secondary" className="px-3 me-2" onClick={() => navigate("/company_admin/document_rules/" + reg_id)}>Discard</Button>
            {rule_id !== undefined
              ? <Button variant="primary" className="px-4 sbmBtn" onClick={() => saveRule(true)}>Update</Button>
              : <Button variant="primary" className="px-4 sbmBtn" onClick={() => saveRule(false)}>Save</Button>}
          </div>
        </div>

      </div>
      {showAllNew && (
        <DocumentModal modalObj={modalObj} callbackModal={callbackDocumentModal} />
      )}
    </div>
  )
};


export default withTranslation()(CreateDocRule);
